import {ReactNode} from "react";
import {css, Theme} from "@emotion/react";
import {elevation} from "@pg-design/elevation";
import {borderRadius, h100, onDesktop, p, ph, textAlign} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

interface IPricingBoxBaseProps {
    children: ReactNode;
    title: ReactNode;
}

export const PricingBoxBase = ({children, title}: IPricingBoxBaseProps) => {
    return (
        <div css={content}>
            <Text css={header} variant="body_copy_1">
                {title}
            </Text>
            {children}
        </div>
    );
};

const divider = (theme: Theme) => css`
    border-bottom: 1px solid ${theme.colors.gray[300]};
`;

const header = (theme: Theme) => css`
    ${p(3)};
    ${divider(theme)};
    ${textAlign("center")};

    ${onDesktop(css`
        ${ph(20)};
    `)}
`;

const content = css`
    ${borderRadius(2)};
    ${elevation(2)};
    background: #fff;
    ${h100};
`;
